import request from "@/api/config.js";

export function createCompany(data) {
  return request({
    url: `company/create`,
    method: "post",
    data,
  });
}

export function updateCompany(id, data) {
  return request({
    url: `company/${id}`,
    method: "put",
    data,
  });
}

export function findCompanyById(id) {
  return request({
    url: `company/${id}`,
    method: "get",
  });
}

export function getStudentsList() {
  return request({
    timeout: 15000,
    url: `company/getStudents/List`,
    method: "get",
  });
}
export function getStudentsListWithoutReadyTasks() {
  return request({
    timeout: 15000,
    url: `company/getStudents/List/WithoutReadyTasks`,
    method: "get",
  });
}

export function getAll() {
  return request({
    url: "company",
    method: "get",
  });
}

export function getAllFullInfo() {
  return request({
    url: "company/getAll/full",
    method: "get",
  });
}

export function downloadFileWithStudents(data) {
  return request({
    url: "company/get/students/file/",
    method: "post",
    data,
  });
}

export function getShortInfo(data) {
  return request({
    url: `company/get-short-info`,
    method: "post",
    data,
  });
}
export function setShortInfo(data) {
  return request({
    url: `company/set-short-info`,
    method: "post",
    data,
  });
}

export function getCompanyList(limit, offset) {
  return request({
    url: `company/get/list/${limit}/${offset}`,
    method: "get"
  });
}
